export enum ZPrinterManufacturer {
  Ingenico = 'ingenico',
  Pax = 'pax',
  Rch = 'rch',
  Epson = 'epson',
  Custom = 'custom',
  Ditron = 'ditron',
  Cima = 'cima',
  Glory = 'glory',
  Cashmatic = 'cashmatic',
  Vne = 'vne',
  Pay_print = 'pay_print',
  Helmac = 'helmac',
  ItalRetail = 'ital_retail',
  Unknown = 'unknown',
  GenericEscPos = 'generic_esc_pos',
  Simulator = 'simulator',
  Mock = 'mock',
}
